import {useRef} from 'react';
import './CSS/Modal.css';

interface ModalProps {
    children: Array<JSX.Element> | JSX.Element;
    isOpen: boolean;
}

const Modal: React.FC<ModalProps> = (props: ModalProps) => {
    const className = useRef('');
    const overlayClassName = useRef('');

    if (props.isOpen === false) {
        className.current = '';
        overlayClassName.current = '';
    } else {
        className.current = 'fadeInModal';
        overlayClassName.current = 'fadeInOverlay';
    }

    return (
        <div>
            <div className={'modal ' + className.current}>{props.children}</div>
        </div>
    );
};

export default Modal;
